/*======================================================================================================================
  * Bluebell: src/app/app.routes.ts
  * Last Edited: 11/12/2024
  * Copyright 2024 Bramble CFD LTD
  * The contents of this file are NOT for redistribution
  * See AUTHORS for list of developers on this project
 =====================================================================================================================*/
import { Routes } from '@angular/router';
import { eulaGuard } from '@app/guards/eula-guard/eula.guard';
import { oauthTokenGuard } from '@app/guards/oauth-token-guard/oauth-token.guard';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('@pages/login/login.component').then(m => m.LoginComponent),
  },
  {
    path: 'logout',
    loadComponent: () => import('@app/pages/logout/logout.component').then(mod => mod.LogoutComponent)
  },
  {
    path: 'eula/:pk',
    loadComponent: () => import('@app/pages/eula/eula.component').then(mod => mod.EulaComponent)
  },
  {
    path: '',
    loadComponent: () => import('@bramble/bramble.component').then(m => m.BrambleComponent),
    loadChildren: () => import('./bramble/bramble.routes').then(m => m.routes),
    canActivateChild: [
      oauthTokenGuard,
      eulaGuard
    ],
  },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: ''
  }
];
